import React from 'react';
import { Tooltip } from '@mui/material';
import { TooltipComponentProps } from './tooltip-component.props';
import { useTooltipOpenForMobile } from './hooks/use-tooltip-open-for-mobile';

export const TooltipComponent = (props: TooltipComponentProps) => {
  const { tooltipRef, handleClick, open } = useTooltipOpenForMobile(props);
  return <Tooltip ref={tooltipRef} open={open} onClick={handleClick} {...props} />;
};
